// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cabecalho_cabecalho__V8p4W {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  transition: all 0.3s ease;
  padding: 1rem 0;
}

.Cabecalho_cabecalhoComFundo__QeODr {
  background: hsl(222, 47%, 6%, 0.9);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid hsl(222, 30%, 18%);
}

.Cabecalho_container__GUWEr {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Cabecalho_logo__VL06R {
  font-family: 'JetBrains Mono', monospace;
  font-size: 1.25rem;
  font-weight: 700;
  color: hsl(217, 91%, 60%);
  text-decoration: none;
}

.Cabecalho_logoPonto__1VHtK {
  color: hsl(250, 70%, 60%);
}

.Cabecalho_navegacao__X23YJ {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.Cabecalho_link__Z-7wE {
  color: hsl(215, 20%, 55%);
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  transition: color 0.2s ease;
  position: relative;
}

.Cabecalho_link__Z-7wE:hover {
  color: hsl(217, 91%, 60%);
}

.Cabecalho_link__Z-7wE::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(135deg, hsl(217, 91%, 60%), hsl(250, 70%, 60%));
  transition: width 0.3s ease;
}

.Cabecalho_link__Z-7wE:hover::after {
  width: 100%;
}

.Cabecalho_menuMobile__x1eCg {
  display: none;
  background: none;
  border: none;
  color: hsl(210, 40%, 92%);
  cursor: pointer;
  padding: 0.5rem;
}

.Cabecalho_menuMobileIcone__ruThO {
  width: 1.5rem;
  height: 1.5rem;
}

.Cabecalho_navegacaoMobile__IFaW8 {
  display: none;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  background: hsl(222, 47%, 6%, 0.98);
  backdrop-filter: blur(12px);
  padding: 1.5rem;
  flex-direction: column;
  gap: 1rem;
  border-bottom: 1px solid hsl(222, 30%, 18%);
}

.Cabecalho_navegacaoMobileAberta__dqSiR {
  display: flex;
}

@media (max-width: 768px) {
  .Cabecalho_navegacao__X23YJ {
    display: none;
  }

  .Cabecalho_menuMobile__x1eCg {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Cabecalho/Cabecalho.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,2EAA2E;EAC3E,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mCAAmC;EACnC,2BAA2B;EAC3B,eAAe;EACf,sBAAsB;EACtB,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".cabecalho {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  transition: all 0.3s ease;\n  padding: 1rem 0;\n}\n\n.cabecalhoComFundo {\n  background: hsl(222, 47%, 6%, 0.9);\n  backdrop-filter: blur(12px);\n  border-bottom: 1px solid hsl(222, 30%, 18%);\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.logo {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: hsl(217, 91%, 60%);\n  text-decoration: none;\n}\n\n.logoPonto {\n  color: hsl(250, 70%, 60%);\n}\n\n.navegacao {\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n}\n\n.link {\n  color: hsl(215, 20%, 55%);\n  text-decoration: none;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: color 0.2s ease;\n  position: relative;\n}\n\n.link:hover {\n  color: hsl(217, 91%, 60%);\n}\n\n.link::after {\n  content: '';\n  position: absolute;\n  bottom: -4px;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(135deg, hsl(217, 91%, 60%), hsl(250, 70%, 60%));\n  transition: width 0.3s ease;\n}\n\n.link:hover::after {\n  width: 100%;\n}\n\n.menuMobile {\n  display: none;\n  background: none;\n  border: none;\n  color: hsl(210, 40%, 92%);\n  cursor: pointer;\n  padding: 0.5rem;\n}\n\n.menuMobileIcone {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.navegacaoMobile {\n  display: none;\n  position: fixed;\n  top: 60px;\n  left: 0;\n  right: 0;\n  background: hsl(222, 47%, 6%, 0.98);\n  backdrop-filter: blur(12px);\n  padding: 1.5rem;\n  flex-direction: column;\n  gap: 1rem;\n  border-bottom: 1px solid hsl(222, 30%, 18%);\n}\n\n.navegacaoMobileAberta {\n  display: flex;\n}\n\n@media (max-width: 768px) {\n  .navegacao {\n    display: none;\n  }\n\n  .menuMobile {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cabecalho": `Cabecalho_cabecalho__V8p4W`,
	"cabecalhoComFundo": `Cabecalho_cabecalhoComFundo__QeODr`,
	"container": `Cabecalho_container__GUWEr`,
	"logo": `Cabecalho_logo__VL06R`,
	"logoPonto": `Cabecalho_logoPonto__1VHtK`,
	"navegacao": `Cabecalho_navegacao__X23YJ`,
	"link": `Cabecalho_link__Z-7wE`,
	"menuMobile": `Cabecalho_menuMobile__x1eCg`,
	"menuMobileIcone": `Cabecalho_menuMobileIcone__ruThO`,
	"navegacaoMobile": `Cabecalho_navegacaoMobile__IFaW8`,
	"navegacaoMobileAberta": `Cabecalho_navegacaoMobileAberta__dqSiR`
};
export default ___CSS_LOADER_EXPORT___;
